import BaseEvent from './base_event';
import * as ItemsFactory from '../../objects/items/items_factory';
import { Rarity } from '../../objects/items/base_item'
import { CockroachesInvasion } from './invasion';
import FriendlyAlien from '../../objects/items/moveable/friendly_alien';
import BreachEvent from './breach';


class Minigame {
    constructor(x, y, stopCb) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'ContainerGame');

        this.bitmap = game.add.bitmapData(400, 300);
        this.sprite = game.add.sprite(x + 350, y - 150, this.bitmap);
        this.stopCb = stopCb;

        //container is on 0,0
        this.position = {
            x: 90,
            y: 280,
            vx: 0.2,
            vy: -0.1,
            ax: 0.1
        };
        this.frame = 0;
        this.redraw();
    }

    redraw() {
        let ctx = this.bitmap.ctx;
        this.bitmap.clear();

        ctx.save();
        ctx.translate(200, 300);
        ctx.rotate(Math.sign(this.position.vx) * Math.min(0.1, Math.abs(0.01 * this.position.vx)));
        ctx.translate(-200, -300);
        ctx.fillStyle = "#3C556B";
        ctx.fillRect(3, 290, 180, 80);
        ctx.fillRect(218, 290, 180, 80);

        ctx.fillStyle = "#ffc000";
        ctx.fillRect(200 - this.position.x, 290 - this.position.y, 10, 10);

        ctx.fillStyle = "#ccc";
        let i = 0;
        for (let y = 295; y >= 250; y -= 10) {
            ctx.globalAlpha = 0.5 + 0.5 * ((40 + this.frame + i) % 40) / 40;
            ctx.fillRect(198, y, 3, 3);
            i++;
        }
        ctx.globalAlpha = 1;
        ctx.restore();
        ctx.strokeStyle = "gray";
        ctx.lineWidth = 3;
        ctx.strokeRect(2, 2, this.bitmap.width - 2, this.bitmap.height - 2);

    }

    updateInput(cursors, keys) {
        this.frame++;
        if (cursors.left.isDown) {
            this.position.ax -= 0.05;
        }
        if (cursors.right.isDown) {
            this.position.ax += 0.05;
        }

        this.position.vx += this.position.ax;
        this.position.vx = Math.max(-3, this.position.vx);
        this.position.vx = Math.min(3, this.position.vx);
        this.position.ax /= 2;
        this.position.vy -= 0.005;
        this.position.x += this.position.vx;
        this.position.y += this.position.vy;

        if (this.position.y <= 5) {
            if (Math.abs(this.position.x) < 20) {
                this.stopCb(true);
            } else {
                this.stopCb(false);
            }
        }

        this.redraw();
    }
}


export default class Container extends BaseEvent {

    static canOccur(gameState) {
        return !gameState.eventsResults.container || (game.time.now - gameState.eventsResults.container.last > 10000);    //todo: limit counts
    }

    enter(gameState) {
        gameState.eventsResults.container = gameState.eventsResults.container || { done: 0, last: 0 };
        gameState.eventsResults.container.done++;
        gameState.eventsResults.container.last = game.time.now;

        let room = gameState.getRandomRoomWithoutHero();

        let letsOpen = (msg) => () => {
            this.ui.showDialog({
                message: msg,
                options: [{
                    text: "Wait! Let’s check with a* cargo scanner* first! ",
                    condition: gameState.has('cargo_scanner'),
                    callback: () => {
                        gameState.history.push({ id: 'cnt', msg: 'sterilized his scavenged cargo just like mama told'});
                        let chance = game.rnd.frac();
                        let item;
                        if (chance < 0.8) {
                            item = ItemsFactory.produceByRarity(room, Rarity.COMMON)[0];
                        } else {
                            item = ItemsFactory.produceByRarity(room, Rarity.RARE)[0];
                        }
                        gameState.items.add(item);
                        this.ui.showDialog({
                            message: `You thoroughly sterilize..errm.. scan the contents of the prized cargo, then pry it open and find… a new ${item.constructor.label}! What a nice day.`,
                            status: "+" + item.constructor.label
                        }, this.end)
                    }
                }, {
                    text: "Open it already!",
                    callback: () => {
                        let chance = game.rnd.frac();
                        let item;
                        if (chance < 0.4) {
                            item = ItemsFactory.produceByRarity(room, Rarity.COMMON)[0];
                            gameState.items.add(item);
                            this.ui.showDialog({
                                message: `You pry it open and find… a new ${item.constructor.label}! What a nice day.`,
                                status: "+" + item.constructor.label
                            }, this.end)
                        } else if(chance < 0.6) {
                            gameState.history.push({ id: 'cnt', msg: 'found a friend in a scavenged cargo'});
                            let item = ItemsFactory.produceMany(room, FriendlyAlien)[0];
                            gameState.items.add(item);

                            this.ui.showDialog({
                                message: `You pry it open to find that something is moving inside. You prepare the chair. It looks at you with a big blue eye and says 'Mommy?'\nYou slowly put the chair away.`,
                                status: "Friendly alien"
                            }, this.end);
                        } else {
                            gameState.history.push({ id: 'cnt', msg: 'infested his ship with space cockroaches'});
                            this.ui.showDialog({
                                message: `You pry it open only to reveal a huge nest of the nasty space cockroaches. Didn’t your mama told you to sanitize your cargo before opening?`,
                                status: "Infestation!"
                            }, () => {
                                this.schedule(CockroachesInvasion, 0);
                                this.end();
                            })
                        }
                    }
                }]
            })
        };

        this.ui.showDialog({
            message: `Radar picks something up. It’s a cargo container! Must be something interesting! Might be even a chair! Too bad your ship is not equipped with a cargo load manipulator. `,
            options: [{
                text: "Ask* nav computer* to correct trajectory and pick up the item safely.",
                condition: gameState.has('navigator'),
                callback: letsOpen("Couple of gut-twisting 10G turns later, your nav computer slowly clears the approach and gently docks the container into your cargo bay. Shall we open it?")
            }, {
                text: "Make a strafing turn and catch the container with your open airlock",
                callback: () => {
                    this.ui.showMinigame("Use left/right to navigate ship\nTry to catch container\ninto the gate", Minigame, (catched) => {
                        if (catched) {
                            gameState.history.push({ id: 'cntB', msg: 'earned a title of Master Cargo Catcher 3000'});
                            letsOpen("You manage to catch the target under the right angle, and it flies right into your cargo dock, crashing and tumbling, but manages to stay intact. Well, it worked out better than you expected. Let’s open it?")();
                        } else {
                            gameState.history.push({ id: 'cntB', msg: 'was bad at calculating relative speeds'});
                            this.ui.showDialog({
                                message: "You manage to catch the target under the right angle, and it flies right into your cargo dock, and then it flies away from the other side of your ship, leaving a nice clean hole in your hull. Congratulations on your lesson of relative speed. Now go fix that.",
                                status: "Hull Breach!"
                            }, () => {
                                this.schedule(BreachEvent, 0);
                            })
                        }
                    });
                }
            }, {
                text: "Eh. No time for scavenging",
                callback: () => {
                    gameState.history.push({ id: 'cnt', msg: 'liked to skip boring events'});
                    this.ui.showDialog({
                        message: "You look at the crate as it passes by. Unspeakable riches inside it will stay hidden from you.. Forever. Time to make some tea."
                    }, this.end)
                }
            }]
        })
    }
}


// WEBPACK FOOTER //
// ./src/states/events/container.js